/**
 *
 * @param list
 */
export const getLargestNumberFromList = (list: number[]) =>
    list.length ? Math.max(...list) : 0;
